import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode, vModelSelect as _vModelSelect, createBlock as _createBlock, withModifiers as _withModifiers } from "vue";
const _hoisted_1 = { class: "card mb-25 border-0 rounded-0 bg-white add-user-card" };
const _hoisted_2 = { class: "card-body p-15 p-sm-20 p-md-25 p-lg-30 letter-spacing" };
const _hoisted_3 = { class: "d-flex justify-content-end align-items-center mb-4" };
const _hoisted_4 = { class: "me-2 fw-medium text-black" };
const _hoisted_5 = { class: "ms-3 d-flex gap-2" };
const _hoisted_6 = ["onClick", "title"];
const _hoisted_7 = { class: "row" };
const _hoisted_8 = {
    key: 0,
    class: "col-md-12"
};
const _hoisted_9 = { class: "form-group mb-15 mb-sm-20 mb-md-25" };
const _hoisted_10 = { class: "d-block text-black fw-semibold mb-10" };
const _hoisted_11 = { class: "col-md-12" };
const _hoisted_12 = { class: "form-group mb-15 mb-sm-20 mb-md-25" };
const _hoisted_13 = { class: "d-block text-black fw-semibold mb-10" };
const _hoisted_14 = ["placeholder"];
const _hoisted_15 = { class: "col-md-12" };
const _hoisted_16 = { class: "form-group mb-15 mb-sm-20 mb-md-25" };
const _hoisted_17 = { class: "d-flex justify-content-between align-items-center mb-2" };
const _hoisted_18 = { class: "d-block text-black fw-semibold mb-0" };
const _hoisted_19 = ["disabled"];
const _hoisted_20 = {
    value: null,
    disabled: ""
};
const _hoisted_21 = ["value"];
const _hoisted_22 = { class: "col-md-12" };
const _hoisted_23 = { class: "form-group mb-15 mb-sm-20 mb-md-25" };
const _hoisted_24 = { class: "d-flex justify-content-between align-items-center mb-3" };
const _hoisted_25 = { class: "d-block text-black fw-semibold mb-0" };
const _hoisted_26 = {
    key: 0,
    class: "badge bg-success"
};
const _hoisted_27 = {
    key: 1,
    class: "badge bg-warning"
};
const _hoisted_28 = { class: "card border-0 shadow-sm mb-3" };
const _hoisted_29 = { class: "card-body" };
const _hoisted_30 = { class: "row" };
const _hoisted_31 = { class: "col-md-12 mb-3" };
const _hoisted_32 = { class: "d-block text-black fw-medium mb-2" };
const _hoisted_33 = ["placeholder"];
const _hoisted_34 = { class: "col-md-6" };
const _hoisted_35 = { class: "form-group mb-15 mb-sm-20 mb-md-25" };
const _hoisted_36 = { class: "d-block text-black fw-semibold mb-10" };
const _hoisted_37 = ["placeholder"];
const _hoisted_38 = { class: "form-text text-muted" };
const _hoisted_39 = { class: "col-md-6" };
const _hoisted_40 = { class: "form-group mb-15 mb-sm-20 mb-md-25" };
const _hoisted_41 = { class: "d-block text-black fw-semibold mb-10" };
const _hoisted_42 = ["src"];
const _hoisted_43 = ["placeholder"];
const _hoisted_44 = ["required"];
const _hoisted_45 = { class: "col-md-6" };
const _hoisted_46 = { class: "form-group mb-15 mb-sm-20 mb-md-25" };
const _hoisted_47 = { class: "d-block text-black fw-semibold mb-10" };
const _hoisted_48 = {
    class: "btn btn-outline-warning",
    type: "button",
    "data-bs-toggle": "modal",
    "data-bs-target": "#contentModalScrollable_ingredientSize"
};
const _hoisted_49 = { class: "mt-10" };
const _hoisted_50 = { key: 0 };
const _hoisted_51 = { class: "table-responsive shadow-sm rounded-2" };
const _hoisted_52 = { class: "table align-middle mb-0 variation-table" };
const _hoisted_53 = { class: "text-uppercase fw-semibold small text-muted" };
const _hoisted_54 = { class: "text-uppercase fw-semibold small text-muted" };
const _hoisted_55 = { class: "fw-semibold text-black" };
const _hoisted_56 = { class: "fw-semibold text-success" };
const _hoisted_57 = {
    key: 1,
    class: "text-warning small fw-medium fst-italic d-inline-flex align-items-center"
};
const _hoisted_58 = { class: "col-md-12" };
const _hoisted_59 = {
    key: 0,
    class: "d-flex align-items-center justify-content-between"
};
const _hoisted_60 = ["disabled"];
const _hoisted_61 = { class: "position-relative" };
const _hoisted_62 = {
    class: "modal fade",
    id: "contentModalScrollable_ingredientTypes",
    tabindex: "-1",
    "aria-hidden": "true"
};
const _hoisted_63 = { class: "modal-dialog modal-dialog-scrollable modal-lg" };
const _hoisted_64 = { class: "modal-content flex-column justify-content-center" };
const _hoisted_65 = { class: "modal-header" };
const _hoisted_66 = { class: "modal-title fs-5" };
const _hoisted_67 = { class: "modal-body" };
const _hoisted_68 = {
    key: 0,
    class: "text-center py-4"
};
const _hoisted_69 = {
    key: 1,
    class: "text-center py-4"
};
const _hoisted_70 = { class: "text-muted" };
const _hoisted_71 = { key: 2 };
const _hoisted_72 = { class: "table-responsive" };
const _hoisted_73 = { class: "table align-middle mb-0" };
const _hoisted_74 = { class: "bg-success text-white" };
const _hoisted_75 = { class: "text-uppercase fw-medium shadow-none text-white fs-13 pt-0" };
const _hoisted_76 = { class: "text-uppercase fw-medium shadow-none text-white fs-13 pt-0" };
const _hoisted_77 = { class: "text-uppercase fw-medium shadow-none text-white fs-13 pt-0 text-end" };
const _hoisted_78 = { class: "fw-semibold text-black" };
const _hoisted_79 = ["onUpdate:modelValue"];
const _hoisted_80 = { class: "text-end" };
const _hoisted_81 = ["onClick", "disabled"];
const _hoisted_82 = { class: "modal-footer" };
const _hoisted_83 = {
    type: "button",
    class: "btn btn-secondary",
    "data-bs-dismiss": "modal"
};
const _hoisted_84 = {
    class: "modal fade",
    id: "contentModalScrollable_ingredientSize",
    tabindex: "-1",
    "aria-hidden": "true"
};
const _hoisted_85 = { class: "modal-dialog modal-dialog-scrollable modal-lg" };
const _hoisted_86 = { class: "modal-content flex-column justify-content-center" };
const _hoisted_87 = { class: "modal-header" };
const _hoisted_88 = { class: "modal-title fs-5" };
const _hoisted_89 = { class: "modal-body" };
const _hoisted_90 = { class: "flex-column" };
const _hoisted_91 = { class: "row" };
const _hoisted_92 = { class: "col-md-6" };
const _hoisted_93 = { class: "form-group mb-15 mb-sm-20 mb-md-25" };
const _hoisted_94 = { class: "d-block text-black fw-semibold mb-10" };
const _hoisted_95 = ["placeholder", "required"];
const _hoisted_96 = { class: "col-md-6" };
const _hoisted_97 = { class: "form-group mb-15 mb-sm-20 mb-md-25" };
const _hoisted_98 = { class: "d-block text-black fw-semibold mb-10" };
const _hoisted_99 = ["placeholder", "required"];
const _hoisted_100 = { class: "col-md-12" };
const _hoisted_101 = { class: "form-group mb-15 mb-sm-20 mb-md-25" };
const _hoisted_102 = ["disabled"];
const _hoisted_103 = { class: "table-responsive flex justify-content-center items-center" };
const _hoisted_104 = { class: "table text-nowrap align-middle mb-0" };
const _hoisted_105 = { class: "bg-success text-white" };
const _hoisted_106 = {
    scope: "col",
    class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
};
const _hoisted_107 = {
    scope: "col",
    class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
};
const _hoisted_108 = { key: 0 };
const _hoisted_109 = { class: "shadow-none lh-1 fw-bold ps-0" };
const _hoisted_110 = { class: "text-decoration-none text-black-emphasis" };
const _hoisted_111 = { class: "shadow-none lh-1 fw-medium" };
const _hoisted_112 = { class: "badge text-outline-danger" };
const _hoisted_113 = { class: "shadow-none lh-1 fw-medium text-body-tertiary" };
const _hoisted_114 = ["onClick"];
const _hoisted_115 = { key: 1 };
const _hoisted_116 = { class: "d-flex justify-content-center align-items-center mt-8" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_v_select = _resolveComponent("v-select");
    const _component_LoaderComponent = _resolveComponent("LoaderComponent");
    const _component_EmptyTable = _resolveComponent("EmptyTable");
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
                _createElementVNode("label", _hoisted_4, _toDisplayString(_ctx.$t('common.language')) + ":", 1),
                _createVNode(_component_v_select, {
                    modelValue: _ctx.selectedLanguage,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((_ctx.selectedLanguage) = $event)),
                    options: _ctx.availableLanguages,
                    label: "name",
                    reduce: (lang) => lang.code,
                    class: "language-selector",
                    style: { "min-width": "150px" }
                }, null, 8, ["modelValue", "options", "reduce"]),
                _createElementVNode("div", _hoisted_5, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.availableLanguages, (lang) => {
                        return (_openBlock(), _createElementBlock("span", {
                            key: lang.code,
                            class: _normalizeClass(["badge",
                                _ctx.isTranslationComplete(lang.code) ? 'bg-success' : 'bg-secondary'
                            ]),
                            style: { "cursor": "pointer" },
                            onClick: ($event) => (_ctx.selectedLanguage = lang.code),
                            title: _ctx.isTranslationComplete(lang.code)
                                ? `${lang.name} - ${_ctx.$t('ingredient.complete')}`
                                : `${lang.name} - ${_ctx.$t('ingredient.incomplete')}`
                        }, _toDisplayString(lang.code.toUpperCase()), 11, _hoisted_6));
                    }), 128))
                ])
            ]),
            _createElementVNode("form", {
                onSubmit: _cache[15] || (_cache[15] = _withModifiers(
                //@ts-ignore
                (...args) => (_ctx.uploadLogo && _ctx.uploadLogo(...args)), ["prevent"]))
            }, [
                _createElementVNode("div", _hoisted_7, [
                    (_ctx.userRole === _ctx.UserRole.FRANCHISE)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                            _createElementVNode("div", _hoisted_9, [
                                _createElementVNode("label", _hoisted_10, _toDisplayString(_ctx.$t('lists.restaurant')) + " * ", 1),
                                _createVNode(_component_v_select, {
                                    modelValue: _ctx.selectedRestaurant,
                                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((_ctx.selectedRestaurant) = $event)),
                                    options: _ctx.restaurantOptions,
                                    label: "name",
                                    reduce: (restaurant) => restaurant.id,
                                    placeholder: _ctx.$t('lists.selectRestaurant'),
                                    class: "restaurant-select",
                                    onInput: _ctx.onRestaurantChange
                                }, null, 8, ["modelValue", "options", "reduce", "placeholder", "onInput"])
                            ])
                        ]))
                        : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_11, [
                        _createElementVNode("div", _hoisted_12, [
                            _createElementVNode("label", _hoisted_13, _toDisplayString(_ctx.$t('common.name')) + " * ", 1),
                            _withDirectives(_createElementVNode("input", {
                                type: "text",
                                class: _normalizeClass(["form-control shadow-none rounded-0 text-black", { 'is-valid': _ctx.validTextField(_ctx.ingredientData.name) }]),
                                placeholder: _ctx.$t('ingredient.namePlaceholder'),
                                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((_ctx.ingredientData.name) = $event)),
                                onChange: _cache[3] || (_cache[3] = (event) => _ctx.handleInput(event, 'name')),
                                required: ""
                            }, null, 42, _hoisted_14), [
                                [_vModelText, _ctx.ingredientData.name]
                            ])
                        ])
                    ]),
                    _createElementVNode("div", _hoisted_15, [
                        _createElementVNode("div", _hoisted_16, [
                            _createElementVNode("div", _hoisted_17, [
                                _createElementVNode("label", _hoisted_18, _toDisplayString(_ctx.$t('ingredient.type')) + " * ", 1),
                                _createElementVNode("button", {
                                    type: "button",
                                    class: "btn btn-sm btn-outline-primary",
                                    "data-bs-toggle": "modal",
                                    "data-bs-target": "#contentModalScrollable_ingredientTypes",
                                    onClick: _cache[4] || (_cache[4] =
                                        //@ts-ignore
                                        (...args) => (_ctx.loadIngredientTypes && _ctx.loadIngredientTypes(...args)))
                                }, [
                                    _cache[22] || (_cache[22] = _createElementVNode("i", { class: "fas fa-cog me-1" }, null, -1)),
                                    _createTextVNode(" " + _toDisplayString(_ctx.$t('ingredient.managePositions')), 1)
                                ])
                            ]),
                            _withDirectives(_createElementVNode("select", {
                                class: _normalizeClass(["form-select shadow-none fw-semibold rounded-0", { 'is-valid': _ctx.ingredientData.ingredientTypeId }]),
                                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event) => ((_ctx.ingredientData.ingredientTypeId) = $event)),
                                onChange: _cache[6] || (_cache[6] = (event) => _ctx.handleInput(event, 'ingredientTypeId')),
                                disabled: _ctx.ingredientTypes.length === 0
                            }, [
                                _createElementVNode("option", _hoisted_20, _toDisplayString(_ctx.$t('ingredient.selectType')), 1),
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sortedIngredientTypes, (type) => {
                                    return (_openBlock(), _createElementBlock("option", {
                                        key: type.id,
                                        value: type.id
                                    }, _toDisplayString(type.label), 9, _hoisted_21));
                                }), 128))
                            ], 42, _hoisted_19), [
                                [_vModelSelect, _ctx.ingredientData.ingredientTypeId]
                            ])
                        ])
                    ]),
                    _createElementVNode("div", _hoisted_22, [
                        _createElementVNode("div", _hoisted_23, [
                            _createElementVNode("div", _hoisted_24, [
                                _createElementVNode("label", _hoisted_25, _toDisplayString(_ctx.$t('ingredient.multilingualTranslations')) + " - " + _toDisplayString(_ctx.getCurrentLanguageName()), 1),
                                (_ctx.isTranslationComplete(_ctx.selectedLanguage))
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_26, [
                                        _cache[23] || (_cache[23] = _createElementVNode("i", { class: "fas fa-check me-1" }, null, -1)),
                                        _createTextVNode(_toDisplayString(_ctx.$t('ingredient.complete')), 1)
                                    ]))
                                    : (_openBlock(), _createElementBlock("span", _hoisted_27, [
                                        _cache[24] || (_cache[24] = _createElementVNode("i", { class: "fas fa-exclamation-triangle me-1" }, null, -1)),
                                        _createTextVNode(_toDisplayString(_ctx.$t('ingredient.incomplete')), 1)
                                    ]))
                            ]),
                            _createElementVNode("div", _hoisted_28, [
                                _createElementVNode("div", _hoisted_29, [
                                    _createElementVNode("div", _hoisted_30, [
                                        _createElementVNode("div", _hoisted_31, [
                                            _createElementVNode("label", _hoisted_32, _toDisplayString(_ctx.$t('common.name')) + " * ", 1),
                                            _withDirectives(_createElementVNode("input", {
                                                type: "text",
                                                class: "form-control shadow-none rounded-0 text-black",
                                                placeholder: _ctx.$t('ingredient.namePlaceholderLang', { lang: _ctx.getCurrentLanguageName() }),
                                                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event) => ((_ctx.currentTranslation.name) = $event)),
                                                onBlur: _cache[8] || (_cache[8] = ($event) => (_ctx.saveTranslation(_ctx.selectedLanguage)))
                                            }, null, 40, _hoisted_33), [
                                                [_vModelText, _ctx.currentTranslation.name]
                                            ])
                                        ])
                                    ])
                                ])
                            ])
                        ])
                    ]),
                    _createElementVNode("div", _hoisted_34, [
                        _createElementVNode("div", _hoisted_35, [
                            _createElementVNode("label", _hoisted_36, _toDisplayString(_ctx.$t('ingredient.ingredientPosition')), 1),
                            _withDirectives(_createElementVNode("input", {
                                type: "number",
                                class: "form-control shadow-none rounded-0 text-black",
                                placeholder: _ctx.$t('ingredient.ingredientPositionPlaceholder'),
                                "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event) => ((_ctx.ingredientData.position) = $event)),
                                onChange: _cache[10] || (_cache[10] = (event) => _ctx.handleInput(event, 'position')),
                                min: "0"
                            }, null, 40, _hoisted_37), [
                                [_vModelText, _ctx.ingredientData.position]
                            ]),
                            _createElementVNode("small", _hoisted_38, _toDisplayString(_ctx.$t('ingredient.ingredientPositionHelp')), 1)
                        ])
                    ]),
                    _createElementVNode("div", _hoisted_39, [
                        _createElementVNode("div", _hoisted_40, [
                            _createElementVNode("label", _hoisted_41, _toDisplayString(_ctx.$t('ingredient.icon')) + " * ", 1),
                            (_ctx.ingredientData.imageUrl)
                                ? (_openBlock(), _createElementBlock("img", {
                                    key: 0,
                                    src: _ctx.ingredientData.imageUrl,
                                    class: "rounded-circle me-8 mb-4",
                                    width: "45",
                                    height: "45",
                                    alt: "ingredient"
                                }, null, 8, _hoisted_42))
                                : _createCommentVNode("", true),
                            _withDirectives(_createElementVNode("input", {
                                type: "text",
                                class: "form-control shadow-none rounded-0 text-black mb-10",
                                placeholder: _ctx.$t('ingredient.imageUrlPlaceholder'),
                                "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event) => ((_ctx.ingredientData.imageUrl) = $event)),
                                onChange: _cache[12] || (_cache[12] = (event) => _ctx.handleInput(event, 'imageUrl'))
                            }, null, 40, _hoisted_43), [
                                [_vModelText, _ctx.ingredientData.imageUrl]
                            ]),
                            _createElementVNode("input", {
                                type: "file",
                                class: "form-control shadow-none rounded-0 text-black",
                                placeholder: "**************",
                                onChange: _cache[13] || (_cache[13] = (event) => _ctx.handleInput(event, 'file')),
                                required: _ctx.actionDetected === 'add' && !_ctx.ingredientData.imageUrl
                            }, null, 40, _hoisted_44)
                        ])
                    ]),
                    _createElementVNode("div", _hoisted_45, [
                        _createElementVNode("div", _hoisted_46, [
                            _createElementVNode("label", _hoisted_47, _toDisplayString(_ctx.$t('ingredient.variationLabel')) + "* ", 1),
                            _createElementVNode("button", _hoisted_48, _toDisplayString(_ctx.actionDetected === "edit"
                                ? _ctx.$t('ingredient.updateVariation')
                                : _ctx.$t('ingredient.addVariation')), 1)
                        ]),
                        _createElementVNode("div", _hoisted_49, [
                            (_ctx.allVariationsIngredientSize.length > 0)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_50, [
                                    _createElementVNode("div", _hoisted_51, [
                                        _createElementVNode("table", _hoisted_52, [
                                            _createElementVNode("thead", null, [
                                                _createElementVNode("tr", null, [
                                                    _createElementVNode("th", _hoisted_53, _toDisplayString(_ctx.$t('ingredient.size')), 1),
                                                    _createElementVNode("th", _hoisted_54, _toDisplayString(_ctx.$t('common.price')), 1)
                                                ])
                                            ]),
                                            _createElementVNode("tbody", null, [
                                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.allVariationsIngredientSize, (variation, index) => {
                                                    return (_openBlock(), _createElementBlock("tr", {
                                                        key: `summary-${index}`
                                                    }, [
                                                        _createElementVNode("td", _hoisted_55, _toDisplayString(variation.size), 1),
                                                        _createElementVNode("td", _hoisted_56, _toDisplayString(_ctx.formatPrice(variation.price)), 1)
                                                    ]));
                                                }), 128))
                                            ])
                                        ])
                                    ])
                                ]))
                                : (_openBlock(), _createElementBlock("div", _hoisted_57, [
                                    _cache[25] || (_cache[25] = _createElementVNode("i", { class: "flaticon-warning lh-1 me-5" }, null, -1)),
                                    _createTextVNode(" " + _toDisplayString(_ctx.$t('ingredient.noSizeAdded')), 1)
                                ]))
                        ])
                    ]),
                    _createElementVNode("div", _hoisted_58, [
                        (_ctx.actionDetected)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_59, [
                                (_ctx.isLoading)
                                    ? (_openBlock(), _createBlock(_component_LoaderComponent, { key: 0 }))
                                    : (_openBlock(), _createElementBlock("button", {
                                        key: 1,
                                        class: _normalizeClass(["default-btn transition border-0 fw-medium text-white pt-10 pb-10 ps-25 pe-25 pt-md-11 pb-md-11 ps-md-35 pe-md-35 rounded-1 fs-md-15 fs-lg-16 bg-success", { 'opacity-50 cursor-not-allowed': !_ctx.isFormValid }]),
                                        type: "submit",
                                        disabled: !_ctx.isFormValid
                                    }, _toDisplayString(_ctx.actionDetected === "edit"
                                        ? _ctx.$t('common.update')
                                        : _ctx.$t('ingredient.addIngredient')), 11, _hoisted_60)),
                                _createElementVNode("button", {
                                    type: "button",
                                    onClick: _cache[14] || (_cache[14] =
                                        //@ts-ignore
                                        (...args) => (_ctx.goBack && _ctx.goBack(...args))),
                                    class: "bg-transparent p-0 border-0 text-danger lh-1 fw-medium"
                                }, [
                                    _cache[26] || (_cache[26] = _createElementVNode("i", { class: "flaticon-delete lh-1 me-1 position-relative top-2" }, null, -1)),
                                    _createElementVNode("span", _hoisted_61, _toDisplayString(_ctx.$t('common.cancel')), 1)
                                ])
                            ]))
                            : _createCommentVNode("", true)
                    ])
                ])
            ], 32)
        ]),
        _createElementVNode("div", _hoisted_62, [
            _createElementVNode("div", _hoisted_63, [
                _createElementVNode("div", _hoisted_64, [
                    _createElementVNode("div", _hoisted_65, [
                        _createElementVNode("h1", _hoisted_66, _toDisplayString(_ctx.$t('ingredient.manageTypePositions')), 1),
                        _cache[27] || (_cache[27] = _createElementVNode("button", {
                            type: "button",
                            class: "btn-close",
                            "data-bs-dismiss": "modal",
                            "aria-label": "Close"
                        }, null, -1))
                    ]),
                    _createElementVNode("div", _hoisted_67, [
                        (_ctx.isLoadingTypes)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_68, [
                                _createVNode(_component_LoaderComponent)
                            ]))
                            : (_ctx.ingredientTypes.length === 0)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_69, [
                                    _createElementVNode("p", _hoisted_70, _toDisplayString(_ctx.$t('ingredient.noTypesAvailable')), 1)
                                ]))
                                : (_openBlock(), _createElementBlock("div", _hoisted_71, [
                                    _createElementVNode("div", _hoisted_72, [
                                        _createElementVNode("table", _hoisted_73, [
                                            _createElementVNode("thead", _hoisted_74, [
                                                _createElementVNode("tr", null, [
                                                    _createElementVNode("th", _hoisted_75, _toDisplayString(_ctx.$t('ingredient.type')), 1),
                                                    _createElementVNode("th", _hoisted_76, _toDisplayString(_ctx.$t('ingredient.position')), 1),
                                                    _createElementVNode("th", _hoisted_77, _toDisplayString(_ctx.$t('common.actions')), 1)
                                                ])
                                            ]),
                                            _createElementVNode("tbody", null, [
                                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sortedIngredientTypes, (type) => {
                                                    return (_openBlock(), _createElementBlock("tr", {
                                                        key: type.label
                                                    }, [
                                                        _createElementVNode("td", _hoisted_78, _toDisplayString(type.label), 1),
                                                        _createElementVNode("td", null, [
                                                            _withDirectives(_createElementVNode("input", {
                                                                type: "number",
                                                                class: "form-control shadow-none rounded-0 text-black",
                                                                "onUpdate:modelValue": ($event) => ((type.position) = $event),
                                                                min: "1",
                                                                style: { "width": "100px" }
                                                            }, null, 8, _hoisted_79), [
                                                                [
                                                                    _vModelText,
                                                                    type.position,
                                                                    void 0,
                                                                    { number: true }
                                                                ]
                                                            ])
                                                        ]),
                                                        _createElementVNode("td", _hoisted_80, [
                                                            _createElementVNode("button", {
                                                                onClick: ($event) => (_ctx.updateTypePosition(type)),
                                                                class: "btn btn-sm btn-primary",
                                                                type: "button",
                                                                disabled: _ctx.isUpdatingPosition
                                                            }, [
                                                                _cache[28] || (_cache[28] = _createElementVNode("i", { class: "fas fa-save me-1" }, null, -1)),
                                                                _createTextVNode(" " + _toDisplayString(_ctx.$t('common.save')), 1)
                                                            ], 8, _hoisted_81)
                                                        ])
                                                    ]));
                                                }), 128))
                                            ])
                                        ])
                                    ])
                                ]))
                    ]),
                    _createElementVNode("div", _hoisted_82, [
                        _createElementVNode("button", _hoisted_83, _toDisplayString(_ctx.$t('common.close')), 1)
                    ])
                ])
            ])
        ]),
        _createElementVNode("div", _hoisted_84, [
            _createElementVNode("div", _hoisted_85, [
                _createElementVNode("div", _hoisted_86, [
                    _createElementVNode("div", _hoisted_87, [
                        _createElementVNode("h1", _hoisted_88, _toDisplayString(_ctx.$t('ingredient.specifySizes')), 1),
                        _cache[29] || (_cache[29] = _createElementVNode("button", {
                            type: "button",
                            class: "btn-close",
                            "data-bs-dismiss": "modal",
                            "aria-label": "Close"
                        }, null, -1))
                    ]),
                    _createElementVNode("div", _hoisted_89, [
                        _createElementVNode("div", _hoisted_90, [
                            _createElementVNode("div", _hoisted_91, [
                                _createElementVNode("div", _hoisted_92, [
                                    _createElementVNode("div", _hoisted_93, [
                                        _createElementVNode("label", _hoisted_94, _toDisplayString(_ctx.$t('ingredient.size')) + "* ", 1),
                                        _withDirectives(_createElementVNode("input", {
                                            type: "text",
                                            class: "form-control shadow-none rounded-0 text-black",
                                            placeholder: _ctx.$t('ingredient.sizePlaceholder'),
                                            "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event) => ((_ctx.ingredientSizeDefine.size) = $event)),
                                            onChange: _cache[17] || (_cache[17] = (event) => _ctx.handleInput(event, 'size')),
                                            required: _ctx.actionDetected === 'add'
                                        }, null, 40, _hoisted_95), [
                                            [_vModelText, _ctx.ingredientSizeDefine.size]
                                        ])
                                    ])
                                ]),
                                _createElementVNode("div", _hoisted_96, [
                                    _createElementVNode("div", _hoisted_97, [
                                        _createElementVNode("label", _hoisted_98, _toDisplayString(_ctx.$t('common.price')) + "* ", 1),
                                        _withDirectives(_createElementVNode("input", {
                                            type: "text",
                                            class: "form-control shadow-none rounded-0 text-black",
                                            placeholder: _ctx.$t('ingredient.pricePlaceholder'),
                                            "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event) => ((_ctx.ingredientSizeDefine.price) = $event)),
                                            onChange: _cache[19] || (_cache[19] = (event) => _ctx.handleInput(event, 'price')),
                                            required: _ctx.actionDetected === 'add'
                                        }, null, 40, _hoisted_99), [
                                            [_vModelText, _ctx.ingredientSizeDefine.price]
                                        ])
                                    ])
                                ]),
                                _createElementVNode("div", _hoisted_100, [
                                    _createElementVNode("div", _hoisted_101, [
                                        _createElementVNode("button", {
                                            onClick: _cache[20] || (_cache[20] =
                                                //@ts-ignore
                                                (...args) => (_ctx.addSizeVariation && _ctx.addSizeVariation(...args))),
                                            class: _normalizeClass(["btn btn-warning btn-sm", {
                                                    'opacity-50 cursor-not-allowed': !_ctx.isFormValidVariation,
                                                }]),
                                            type: "button",
                                            disabled: !_ctx.isFormValidVariation
                                        }, _toDisplayString(_ctx.$t('common.add')), 11, _hoisted_102)
                                    ])
                                ])
                            ]),
                            _createElementVNode("div", _hoisted_103, [
                                _createElementVNode("table", _hoisted_104, [
                                    _createElementVNode("thead", _hoisted_105, [
                                        _createElementVNode("tr", null, [
                                            _createElementVNode("th", _hoisted_106, _toDisplayString(_ctx.$t('ingredient.size').toUpperCase()), 1),
                                            _createElementVNode("th", _hoisted_107, _toDisplayString(_ctx.$t('common.price').toUpperCase()), 1)
                                        ])
                                    ]),
                                    (_ctx.allVariationsIngredientSize &&
                                        _ctx.allVariationsIngredientSize.length > 0)
                                        ? (_openBlock(), _createElementBlock("tbody", _hoisted_108, [
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.allVariationsIngredientSize, (variation, index) => {
                                                return (_openBlock(), _createElementBlock("tr", { key: index }, [
                                                    _createElementVNode("th", _hoisted_109, [
                                                        _createElementVNode("span", _hoisted_110, _toDisplayString(variation.size), 1)
                                                    ]),
                                                    _createElementVNode("td", _hoisted_111, [
                                                        _createElementVNode("span", _hoisted_112, _toDisplayString(variation.price) + " CHF", 1)
                                                    ]),
                                                    _createElementVNode("td", _hoisted_113, [
                                                        _createElementVNode("button", {
                                                            onClick: ($event) => (_ctx.removeSizeVariation(variation)),
                                                            class: "btn btn-danger btn-sm",
                                                            type: "button"
                                                        }, _toDisplayString(_ctx.$t('ingredient.remove')), 9, _hoisted_114)
                                                    ])
                                                ]));
                                            }), 128))
                                        ]))
                                        : (_openBlock(), _createElementBlock("tbody", _hoisted_115, [
                                            _createElementVNode("tr", null, [
                                                _createVNode(_component_EmptyTable, {
                                                    message: _ctx.$t('ingredient.noSizeAddedModal'),
                                                    colspan: 8,
                                                    textClass: "text-muted"
                                                }, null, 8, ["message"])
                                            ])
                                        ]))
                                ])
                            ]),
                            _createElementVNode("div", _hoisted_116, [
                                _createElementVNode("button", {
                                    onClick: _cache[21] || (_cache[21] = ($event) => (_ctx.updateVariationProduct(_ctx.ingredientResponse?.id))),
                                    class: "btn btn-primary btn-sm",
                                    type: "button",
                                    "data-bs-dismiss": "modal",
                                    "aria-label": "Close"
                                }, _toDisplayString(_ctx.$t('common.confirm')), 1)
                            ])
                        ])
                    ])
                ])
            ])
        ])
    ]));
}
